(ns livefeed.message-filter
  (:require [reagent.core :as r :refer [with-let]]
            [livefeed.i18n :refer [translate]]
            ["@yleisradio/yds-components-react" :refer [DropdownMenu]]))

(defn component [selected-item on-select-item]
  (with-let [option-all #js {:value "all" :text (translate :live)}
             option-best #js {:value "best" :text (translate :best)}
             options #js [option-all option-best]]
    [:div.yle-livefeed__tabs
     [:> DropdownMenu {:class-name        "yle-livefeed__message-filter"
                       :options           options
                       :align-menu "left"
                       :value             selected-item
                       :on-change         (fn [value]
                                            (on-select-item value))}]]))
